module.exports = __webpack_public_path__ + "img/bag_of_dragons.cdba7003.jpg";